<template>
  <div :class="'md-layout'">
    <div :class="'md-layout-item md-size-100'">
      <md-card>
        <md-card-header :class="'md-card-header-icon md-card-header-danger'">
          <div :class="'card-icon'">
            <md-icon>assignment</md-icon>
          </div>
          <h4 :class="'title'">
            List
            <md-button :class="'md-danger pull-right'" @click.prevent="$router.push({ name: 'Create Review Reference' })"
              v-if="cannotView() && advisories.length > 0">
              New
            </md-button>
          </h4>
        </md-card-header>                
        <md-card-content>
          
          <!--Filters-->
          <div :class="'md-layout'">
            <div :class="'md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-33 md-large-size-33'">
              <md-field>
                <label>Reference</label>
                <md-input placeholder="Reference" v-model="filter.reference" />
              </md-field>
            </div>
            <div :class="'md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-33 md-large-size-33'">
              <md-field md-clearable>
                <label>Fiscal year</label>
                <md-select placeholder="Fiscal year" v-model="filter.fiscal_year">
                  <md-option :value="year" :key="idx" v-for="(year, idx) in fiscalYears">
                    {{ year }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
            <div :class="'md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-33 md-large-size-33'">
              <md-field md-clearable>
                <label>RQR Type</label>
                <md-select placeholder="RQR Type" v-model="filter.rqr_type" md-dense>                
                  <md-option :value="code" :key="code" v-for="(type, code) in rqrTypesMap">
                    {{ type }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
          </div>

          <!--Table-->
          <md-table v-model="advisories" table-header-color="orange">
            <md-empty-state md-icon="list" :md-label=" 'No ARR found' + (this.filtersQuery ? ' with the searched terms' : '')"
              md-description="Create the first Review Reference" v-if="!isFetching && advisories.length === 0">
              <md-button :class="'md-primary md-raised'" @click.prevent=" $router.push({ name: 'Create Review Reference' })">
                New ARR
              </md-button>
            </md-empty-state>
            <md-table-row slot="md-table-row" slot-scope="{ item: arr }">
              <md-table-cell md-label="Review Reference">
                <router-link :to="{ name: 'Reviews', query: { advisory: arr.id } }" :style="'color: black'">
                  <md-icon>search</md-icon> {{ arr.reference }}
                </router-link>
              </md-table-cell>
              <md-table-cell md-label="Fiscal Year">{{ arr.fiscal_year }}</md-table-cell>
              <md-table-cell md-label="RQR Type">{{ arr.rqr_type | rqrType }}</md-table-cell>
              <md-table-cell md-label="Start Date">{{ arr.start_date | date }}</md-table-cell>
              <md-table-cell md-label="End Date">{{ arr.end_date | date }}</md-table-cell>
              <md-table-cell md-label="Deadline docs">{{ arr.deadline_docs | date }}</md-table-cell>
              <md-table-cell md-label="RQR Leader">{{ arr.leader ? arr.leader.name : "-" }}</md-table-cell>
              <md-table-cell v-if="cannotView()" md-label="Actions" md-numeric>
                <md-button :class="'md-simple md-just-icon'" :md-ripple="false" @click.prevent="
                  $router.push({
                    name: 'Edit Review Reference',
                    params: { id: arr.id },
                  })" title="Edit Reference">
                  <md-icon>edit</md-icon>
                </md-button>
                <md-button :class="'md-simple md-just-icon'" :md-ripple="false" 
                @click.prevent="tryToDelete(arr)" title="Delete Reference">
                  <md-icon>delete</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
          <div :class="'md-flex text-center'" v-if="advisories.length > 0">
            <Pagination :total="pagination.totalItems" :value="pagination.currentPage" 
              :perPage="pagination.perPage" @input="changePage"/>
          </div>
          <div :class="'md-flex text-center'" v-if="isFetching">
            <md-progress-spinner :class="'md-accent'" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
          </div>
        </md-card-content>
      </md-card>
    </div>

    <md-dialog :md-active.sync="isTryingToDelete">
      <md-dialog-title>Delete Reference</md-dialog-title>
      <md-dialog-content v-if="deletableARR">
        Are you sure you want to delete
        <b>{{ deletableARR.reference }} - {{ deletableARR.rqr_type | rqrType }} ({{deletableARR.fiscal_year}})</b>?
      </md-dialog-content>
      <md-dialog-actions>
        <md-button :disabled="isDeletingARR" @click.prevent="dismissDeleteModal">Cancel</md-button>
        <md-button :class="'md-primary'" :disabled="isDeletingARR" @click.prevent="deleteARR(deletableARR)">
          {{ !isDeletingARR ? "Delete" : "Deleting..." }}
        </md-button>
      </md-dialog-actions>
    </md-dialog>  
  </div>
</template>

<script>
import { date, rqrType } from "@/filters";
import { rqrTypesMap } from "@/filters/rqrType";
import { Pagination } from "@/components";
import { camelToSnake } from "@/methods/api/requests";
import * as utils from "@/utils";
import * as filters from "@/filters";

export default {
  created() {
    this.filter["reference"] = this.$store.state["ARRlistingFilters"]["reference"];
    this.filter["fiscal_year"] = this.$store.state["ARRlistingFilters"]["fiscal_year"];
    this.filter["rqr_type"] = this.$store.state["ARRlistingFilters"]["rqr_type"];
    this.getAdvisories();
  },

  data() {
    return {
      advisories: [],
      isFetching: false,
      isTryingToDelete: false,
      isDeletingARR: false,
      deletableARR: null,
      filter: {
        reference: null,
        fiscal_year: null,
        rqr_type: null,
      },
      pagination: {
        totalItems: "",
        currentPage: "",
        perPage: "",
      },
      advisoriesDebounceTimer: null,
      rqrTypesMap,
    };
  },

  components: {
    Pagination,
  },

  computed: {
    filtersQuery() {
      return filters.getFiltersQuery(this.filter);
    },
    
    fiscalYears() {
      return utils.getFiscalYears();
    },

    paginationQuery() {
      return utils.getPaginationQuery(this.pagination.currentPage);
    },
  },

  filters: {
    date,
    rqrType,
  },

  methods: {
    cannotView() {
      return utils.getCannotView(this.$store.state.currentProfile)
    },

    changePage(toPage) {
      if (toPage === this.pagination.currentPage)
        return;      

      this.pagination.currentPage = toPage;
      this.getAdvisories();
    },

    deleteARR() {
      if (this.isDeletingARR)
        return;      

      this.isDeletingARR = true;
      this.$api.request
        .delete(`advisories/${this.deletableARR.id}`)
        .then(() => {
          this.dismissDeleteModal();
          this.$toast.show(
            `Reference <b>${this.deletableARR.reference} (${this.deletableARR.fiscal_year})</b> was deleted successfully`,
            "ARR deleted successfully"
          );

          this.getAdvisories();
        })
        .catch((err) => {
          this.$toast.warning(err.response.data.message, "");
        })
        .finally(() => {
          this.isTryingToDelete = false;
          this.isDeletingARR = false;
        });
    },
    
    dismissDeleteModal() {
      if (this.isDeletingARR)
        return;
      
      this.isTryingToDelete = false;
    },

    getAdvisories() {
      this.isFetching = true;
      this.$api
        .request(`advisories?${this.filtersQuery}${this.paginationQuery}`)
        .then((response) => {
          this.advisories = camelToSnake(response.data.data);
          this.pagination.totalItems = response.data.meta.total;
          this.pagination.currentPage = response.data.meta.currentPage;
          this.pagination.perPage = response.data.meta.perPage;
        })
        .finally(() => {
          this.isFetching = false;
        });
    },

    tryToDelete(arr) {
      this.isTryingToDelete = true;
      this.deletableARR = arr;
    },
  },

  watch: {
    filtersQuery() {
      this.$store.commit("ARRLISTINGFILTERS", this.filter);
      clearTimeout(this.advisoriesDebounceTimer);      
      this.advisoriesDebounceTimer = setTimeout(() => this.getAdvisories(), 500);
    },
  },
};
</script>